import React from "react";
import ReactDOM from "react-dom";
import ReactModal from "react-modal";

const Modal = ({ children, ...props }) => {
	return ReactDOM.createPortal(
		<ReactModal
			{...props}
			role="dialog"
			overlayClassName="overlay-modal"
			ariaHideApp={false}
			closeTimeoutMS={300}
		>
			{children}
		</ReactModal>,
		document.getElementById("portal"),
	);
};

export default Modal;
